import { useUserStore } from '../../../store/models';

// Access is granted only to specific internal test/super-admin publisher IDs — none belong to real clients or customers.
const DEV_ACCESS_IDS = {
    prod:  [479699, 15310, 471532],
    stage: [14292, 14620, 12471, 14277],
    dev:   [14389, 14990, 12471, 14370],
};

function useConnectIntegrationByDev () {
    const userStore = useUserStore();
    // Read the observed token so MobX resubscribes when a superadmin switches publisher.
    void userStore.observed.publisher;
    const publisherId = userStore.publisher?.publisherId;
    const env = import.meta.env.VITE_ENV_VAR || 'dev';

    const allowedIds = DEV_ACCESS_IDS[env] || DEV_ACCESS_IDS.dev;
    const devAccess = allowedIds.includes(Number(publisherId));

    return {
        devAccess,
    };
}

export default useConnectIntegrationByDev;
